(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/skeleton-coupon.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/skeleton-coupon.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.SkeletonCoupon = Marionette.View.extend({
    className: 'bg-white',
    regions: {
      drawSelector: '#drawChooser',
      matchlist: '#matchlist'
    },
    templateContext: function() {
      var noDraws = svs.maltipset.data.config.noDraws;
      var noOpenDrawsMessageStart = noDraws ? noDraws.errorText : 'just nu finns det ingen spelbar omgång';
      var noOpenDrawsMessageEnd = noDraws ? noDraws.errorTextEnd : '- Välkommen tillbaka!';
      var numberOfMatches = svs.maltipset.constants.NUMBER_OF_MATCHES;
      return {
        noOpenDrawsMessageEnd: noOpenDrawsMessageEnd,
        noOpenDrawsMessageStart: noOpenDrawsMessageStart,
        numberOfMatches: numberOfMatches
      };
    },
    template: function(data) {
      return svs.maltipset.templates.skeleton_coupon(data);
    }
  });
})(Backbone, _, svs);


 })(window);